import { FC } from "react";

import { useTranslator } from "@/i18n/useTranslator";

import { DsText, DsTextPropsType } from "../components/ui";
import { useServiceQuery } from "../data/queries/serviceQueries";

type CustomerNameTextPropsType = Pick<DsTextPropsType, "variant"> & {
  jobId: string;
  serviceId: string;
  className?: string;
};

export const CustomerNameText: FC<CustomerNameTextPropsType> = ({
  jobId,
  serviceId,
  variant,
  className,
}) => {
  const { t } = useTranslator();

  // Get task's parent service data
  const { data: serviceData } = useServiceQuery({ jobId, serviceId });

  let text = serviceData?.customer?.name;

  if (!text) {
    text = t("dashboard_customer_name_text_block.customer_not_found");
  }

  return (
    <DsText variant={variant} className={className}>
      {text}
    </DsText>
  );
};
